import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchWishlist } from "./features/wishlistSlice";
import WishlistData from "./WishlistData";

const Wishlist = () => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const wishlistItems = useSelector(
    (state) => state?.wishlist?.wishlistItems || []
  );
  
  useEffect(() => {
    window.scrollTo(0, 0);
    if (user && token) {
      dispatch(fetchWishlist());
    }
    // Ensure loader shows for at least 0.4 seconds
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, [dispatch, user, token]);

  if (isPageLoading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }

  return (
    <>
      <style>
        {`
          .wishlist-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(60, 50, 96, 0.8); /* Your theme color with opacity */
            z-index: 1000;
            display: flex;
            justify-content: center;
            align-items: center;
            backdrop-filter: blur(5px);
          }

          .login-prompt {
            background: white;
            padding: 2rem;
            border-radius: 10px;
            text-align: center;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            max-width: 90%;
            width: 400px;
            animation: slideIn 0.3s ease-out;
          }

          .login-prompt h2 {
            color: #3c3260;
            margin-bottom: 1rem;
            font-size: 1.5rem;
          }

          .login-prompt p {
            color: #666;
            margin-bottom: 1.5rem;
          }

          .login-btn {
            background: #3c3260;
            color: white;
            border: none;
            padding: 0.75rem 2rem;
            border-radius: 25px;
            font-weight: 500;
            transition: all 0.3s ease;
            text-decoration: none;
            display: inline-block;
          }

          .login-btn:hover {
            background: #4a3e78;
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }

          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .content-blur {
            filter: blur(4px);
          }
        `}
      </style>
      <div>
        <section className="banner-innr" style={{ background: "#3c3260" }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12">
                <div className="banner-innr-content">
                  <h3 style={{ color: "white" }}>My Wishlist</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="product-sec product-page tp-space mt-3">
          <div className="container">
            {wishlistItems?.length === 0 ? (
              <>
                <div className="text-center mb-4">
                  <h1>Your wishlist is empty.</h1>
                  <Link
                    to="/shop"
                    style={{ borderRadius: "50px"}}
                    className="thm-btn mt-2"
                  >
                    Continue Shopping
                  </Link>
                </div>
              </>
            ) : (
              <div className="row">
                {/* {console.log("WishlistData inside wishlistData", wishlistItems)} */}
                {wishlistItems.map((product) => (
                  <WishlistData key={product._id} product={product} />
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default Wishlist;
